export class WaitlistEntryDTO {
    constructor(
        public id: string,
        public organisationId: string,
        public venueId: string,
        public firstName: string,
        public lastName: string,
        public emailAddress: string,
        public phoneNumber: string | null,
        public merchantNotes: string | null,
        public partySize: number,
        public date: string,
        public time: string,
        public reasonId: string | null,
        public eventId: string | null,
        public requiresWheelchairAccess: boolean,
        public requiresDogFriendly: boolean,
        public requiresPramAccessible: boolean,
        public requiresHighchairFriendly: boolean,
        public dateCreated: string,
        public dateUpdated: string,
        public numberOfTimesPrompted: number = 0,
        public dateLastPrompted: string | null = null,
    ) { }
}

export class CreateWaitlistEntryDTO {
    constructor(
        public firstName: string,
        public lastName: string,
        public emailAddress: string,
        public phoneNumber: string | null,
        public merchantNotes: string | null,
        public partySize: number,
        public date: string,
        public time: string,
        public reasonId: string | null,
        public eventId: string | null,
        public requiresWheelchairAccess: boolean,
        public requiresDogFriendly: boolean,
        public requiresPramAccessible: boolean,
        public requiresHighchairFriendly: boolean,
    ) { }
}

export class CreateWaitlistEntryWithOptionsDTO {
    constructor(
        public entry: CreateWaitlistEntryDTO,
        public sendViaEmail: boolean,
    ) { }
}

export class UpdateWaitlistEntryMerchantNotesDTO {
    constructor(
        public merchantNotes: string | null,
    ) { }
}

export class WaitlistEntryAuditEntryDTO {
    constructor(
        public id: string,
        public waitlistEntryId: string,
        public changes: { [key: string]: any },
        public userId: string | null,
        public dateTime: string,
    ) { }
}

export class PromptWaitlistEntriesDTO {
    constructor(
        public entryIds: string[],
    ) { }
}

export class ConvertWaitlistEntryDTO {
    constructor(
        public tableIds: string[],
        public areaId: string,
        public durationMinutes: number,
    ) { }
}

export class WaitlistEntryCountDTO {
    constructor(
        public count: number,
    ) { }
}
